import { RAW_NAV_MENU } from '@/config/navMenu'

/**
 * 菜单未覆盖的资讯栏目（仍挂在 /news/list）
 */
const EXTRA_BY_COLUMN_ID = {
	4: { sectionTitle: null, leafTitle: '协会动态', route: { path: '/news/list', query: { id: '4' } } },
	5: { sectionTitle: null, leafTitle: '供需对接', route: { path: '/news/list', query: { id: '5' } } },
	18: { sectionTitle: '企业赋能', leafTitle: '服务专项', route: { path: '/news/list', query: { id: '18' } } }
}

function buildColumnIndex() {
	const map = new Map()
	for (const section of RAW_NAV_MENU) {
		if (!section.list) continue
		const sectionTitle = section.title
		for (const sub of section.list) {
			const to = sub.to
			if (!to || to === 'false' || typeof to === 'string') continue
			const id = to.query && to.query.id != null ? String(to.query.id) : null
			if (id != null) {
				map.set(id, {
					sectionTitle,
					leafTitle: sub.title,
					route: { path: to.path, query: { ...to.query } }
				})
			}
		}
	}
	for (const [id, meta] of Object.entries(EXTRA_BY_COLUMN_ID)) {
		if (!map.has(id)) map.set(id, meta)
	}
	return map
}

const COLUMN_INDEX = buildColumnIndex()

/**
 * @param {string|number|undefined|null} columnId - 详情页路由 query.id（栏目 id）
 * @param {object} [opts]
 * @param {string} [opts.tail] 末级文案，默认「详情」
 * @returns {{ title: string, to?: { path: string, query?: object }, current?: boolean }[]}
 */
export function getDetailBreadcrumbItems(columnId, opts = {}) {
	const tail = opts.tail != null ? opts.tail : '详情'
	const id = columnId != null && columnId !== '' ? String(columnId) : ''
	const items = [{ title: '首页', to: { path: '/' } }]

	if (!id) {
		items.push({ title: tail, current: true })
		return items
	}

	const hit = COLUMN_INDEX.get(id)
	if (!hit) {
		items.push({ title: tail, current: true })
		return items
	}

	if (hit.sectionTitle) {
		items.push({ title: hit.sectionTitle })
	}
	items.push({
		title: hit.leafTitle,
		to: hit.route
	})
	items.push({ title: tail, current: true })
	return items
}
